import { render, staticRenderFns } from "./CounterEdit.vue?vue&type=template&id=487e8c3c&"
import script from "./CounterEdit.vue?vue&type=script&lang=js&"
export * from "./CounterEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports